module.exports = __webpack_public_path__ + "media/images/avatar-default-icon-dfead413848e4732e81b168ba7b2af2c.png";